import { ApiService } from '../../../services/api_service';
import { CellInfo } from 'react-table-6';
import { DataService } from '../../../services/data_service';
import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { RegistrierungenDialog } from './RegistrierungenDialog';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

interface RegistrierungenProps extends React.ClassAttributes<any> {
    data: any;
    standortSelected: any;
}

interface RegistrierungenState {
    data: Array<any>;
    showRegProcess: boolean;
    selectedRegRow: any;
    refreshStamp: number;
    bereicheData: Array<any>;
    showSchulung: boolean;
    showSpinner: boolean;
}

export class Registrierungen extends React.Component<RegistrierungenProps, RegistrierungenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            showRegProcess: false,
            selectedRegRow: undefined,
            refreshStamp: new Date().getTime(),
            bereicheData: null,
            showSchulung: false,
            showSpinner: false
        };
        this.customValidate = this.customValidate.bind(this);
        this.apiMultiBereichKeys = this.apiService.getMultiBereichKeys();
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private mails: any = {};
    private apiMultiBereichKeys: Array<string>;

    componentDidMount(): void {
        this.loadData();
    }

    loadData(): void {
        this.setState({ showSpinner: true }, () => {
            this.dataService.loadData(IDs.ENT_USER_LOGIN, {}, { fieldList: 'name, datum, anzahl' }, (dataLogin: any) => {
                this.dataService.loadData(IDs.ENT_USER, {}, { fieldList: 'tid, Mail' }, (dataUser: any) => {
                    this.mails = {};
                    const data: Array<any> = [];
                    const logins: Array<any> = dataLogin[IDs.ENT_USER_LOGIN] || [];
                    const hasAllBereich = this.apiMultiBereichKeys.indexOf('all') !== -1;
                    (this.props.data[IDs.ENT_REGISTRIERUNG] || [])
                        .filter((r: any) => hasAllBereich || this.apiMultiBereichKeys.indexOf(r.bereich_key_orig) !== -1)
                        .forEach((item: any) => {
                            const login: any = logins.find((item2: any) => (item2.name || null) === (item.mandant_key || null)) || {};
                            this.mails[item.tid] = (item.mail || '').toLowerCase();
                            data.push({
                                ...item,
                                lastLogin: (login || {}).datum ? login.datum : null,
                                countLogin: +(login || {}).anzahl || null
                            })
                        });
                    (this.props.data[IDs.ENT_BERATER] || []).forEach((item: any) => {
                        this.mails[`b${item.tid}`] = (item.mail || '').toLowerCase();
                    });
                    ((dataUser || {})[IDs.ENT_USER] || []).forEach((item: any) => {
                        this.mails[`u${item.tid}`] = (item.Mail || '').toLowerCase();
                    });
                    this.setState({ data, showSpinner: false, refreshStamp: new Date().getTime() });
                }, IDs.MOD_LEGACY);
            }, IDs.MOD_ETOOL_ADMIN);

            this.dataService.loadData(IDs.ENT_BRANCHEN_BEREICHE, {}, {}, (res: any) => {
                if (res && Array.isArray(res[IDs.ENT_BRANCHEN_BEREICHE])) {
                    this.setState({ bereicheData: res[IDs.ENT_BRANCHEN_BEREICHE] });
                }
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    render(): JSX.Element {
        if (!this.state.data) {
            return null;
        }

        const customFormatter = (key: string, value: any, data: any, row: any) => {
            if (value === undefined || value === null) {
                return '';
            }
            return value;
        };

        const showData = (this.state.data || []).filter((r: any) => this.state.showSchulung || !r.schulung_orig);

        return (
            <div>
                {this.state.showSpinner && <WSpinner />}
                <WFormsTableWrapper
                    entity={IDs.ENT_REGISTRIERUNG}
                    module={IDs.MOD_ETOOL_ADMIN}
                    data={showData}
                    customClass={'Custom-ETA'}
                    customFormatter={customFormatter}
                    formLayout={'flowV2'}
                    actions={['edit', 'delete', 'add']}
                    externalHeaderElements={this.getExternalHeaderElements()}
                    customActions={this.getCustomActions()}
                    customColumns={this.getCustomColumns()}
                    showColumnsHelp
                    hiddenColumns={['password', 'schulung']}
                    validateField={this.customValidate}
                    refreshStamp={this.state.refreshStamp}
                    formGroupOrder={this.getFormGroupOrder()}
                    bundle={{ bereich_key: this.state.bereicheData }}
                    customFormConfig={this.getCustomFormConfig()}
                    onDelDone={() => this.triggerService.fire('admin_reload', IDs.ENT_REGISTRIERUNG)}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_REGISTRIERUNG)}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' || action === 'delDone') {
                            this.loadData();
                            // this.triggerService.fire('admin_reload', IDs.ENT_REGISTRIERUNG);
                        }
                    }}
                    callBeforeOnFormSave={(data: any, callback: () => void) => {
                        if (data.mail) {
                            this.apiService.call('checkMailExistence', { mail: data.mail, tid: data.tid, entity: IDs.ENT_REGISTRIERUNG, module: IDs.MOD_ETOOL_ADMIN },
                                (res: string, suc: boolean) => {
                                    // console.log(res, suc);
                                    if (suc) {
                                        if (res === '1') {
                                            alert('E-Mail-Adresse existiert bereits.');
                                        } else {
                                            callback();
                                        }
                                    } else {
                                        alert('Server Error');
                                    }
                                }
                            );
                        }
                    }}
                />
                {this.state.showRegProcess &&
                    <RegistrierungenDialog
                        data={this.props.data}
                        row={this.state.selectedRegRow}
                        onClose={() => this.setState({ showRegProcess: false, selectedRegRow: undefined })}
                        onReload={(entity: string) => {
                            this.triggerService.fire('admin_reload', entity);
                            this.setState({ refreshStamp: new Date().getTime() });
                        }}
                    />
                }
            </div>
        );
    }

    getFormGroupOrder() {
        const formGroupOrder = [
            {
                title: i18n('Pflichtangaben', 'sys'),
                titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                foldable: false,
                folded: false,
                fields: ['unternehmen', 'bereich_key', 'mail', 'password', 'mail_confirmed', 'active', 'datum_active_until', 'test_registrierung', 'newsletter_abo']
            },
            {
                title: i18n('Optionale Angaben', 'sys'),
                titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                foldable: true,
                folded: true,
                fields: ['name', 'vorname', 'strasse', 'hausnummer', 'ort', 'plz', 'telefon']
            }
        ];
        return formGroupOrder;
    }

    getCustomFormConfig() {
        const customFormConfig = {
            datum_active_until: {
                autofill: false,
                hidden: false,
                custom_component: (setValue?: (value: number) => void) =>
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                        <WActionButton
                            label='Für 3 Tage'
                            insideText='Für 3 Tage'
                            action='edit'
                            key='add_3_days'
                            onAction={() => setValue(Moment().add({ days: 3 }).unix())}
                        />
                        <WActionButton
                            divStyle={{ marginLeft: 10 }}
                            label='Für 7 Tage'
                            insideText='Für 7 Tage'
                            action='edit'
                            key='add_7_days'
                            onAction={() => setValue(Moment().add({ days: 7 }).unix())}
                        />
                    </div>
            }
        }
        return customFormConfig;
    }

    getCustomColumns() {
        const customColumns: Array<any> = [
            {
                id: 'schulungstools',
                Header: 'Schulungstools',
                HeaderText: 'Schulungstools',
                accessor: 'schulung_orig',
                filterable: false,
                Cell: (row: CellInfo) => {
                    return row.original && row.original.schulung_orig > 0 ? 'Ja' : 'Nein';
                },
                sortMethod: (a: any, b: any) => {
                    // accessor: 'schulung_orig' !!!
                    a = typeof a === 'number' ? a : 0;
                    b = typeof b === 'number' ? b : 0;
                    return a - b;
                }
            },
            {
                accessor: 'datum_active_until',
                Header: 'Freigeschaltet bis',
                HeaderText: 'Freigeschaltet bis',
                id: 'datum_active_until',
                filterable: false,
                Cell: (row: CellInfo) => {
                    if (row.original && typeof row.original.datum_active_until === 'number') {
                        const date = Moment.unix(row.original.datum_active_until).format('DD.MM.YYYY');
                        const now = Moment().unix();
                        if (row.original.datum_active_until >= now) {
                            return date;
                        } else {
                            return <span style={{ color: 'red' }}>Gesperrt am {date}</span>;
                        }
                    }
                    return null;
                }
            },
            {
                accessor: 'lastLogin',
                Header: 'Letzter Login',
                HeaderText: 'Letzter Login',
                id: 'lastLogin',
                filterable: false,
                Cell: (row: CellInfo) => row.original
                    ? (row.original.lastLogin ? Moment.unix(row.original.lastLogin).format('DD.MM.YYYY') : null)
                    : (row.value ? Moment.unix(row.value).format('DD.MM.YYYY') : null)
            },
            {
                accessor: 'countLogin',
                Header: 'Logins',
                HeaderText: 'Logins',
                id: 'countLogin',
                filterable: false,
                Cell: (row: CellInfo) => row.original
                    ? (row.original.countLogin ? row.original.countLogin : null)
                    : (row.value ? row.value : null)
            }
        ];
        return customColumns;
    }

    getCustomActions() {
        const customActions = [
            {
                label: 'Kontaktverknüpfung bearbeiten',
                info: 'Kontaktverknüpfung bearbeiten',
                key: 'config',
                func: (row: any) => {
                    this.setState({
                        showRegProcess: true,
                        selectedRegRow: row
                    });
                }
            },
            {
                label: 'Im E-Tool ansehen',
                info: 'Im E-Tool ansehen',
                key: 'show',
                func: (row: any) => {
                    const curUrl = new URL(window.location.href);
                    const url = curUrl.origin + curUrl.pathname.substring(0, curUrl.pathname.lastIndexOf('/') + 1);
                    const params = {
                        adminUser: this.apiService.getUsername(),
                        adminToken: this.apiService.getToken(),
                        mandantKey: row.mandant_key
                    };
                    // console.log(row, params, url);
                    const eToolPage = window.open(url)
                    const script = document.createElement('script');
                    script.innerHTML = 'parameter="' + window.btoa(JSON.stringify(params)) + '"';
                    eToolPage.document.body.appendChild(script);
                    eToolPage.focus();
                }
            }
        ];
        return customActions;
    }

    getExternalHeaderElements(): JSX.Element[] {
        const style: React.CSSProperties = {
            cursor: 'pointer', display: 'flex', alignItems: 'center', height: 28, marginTop: 2, fontSize: 12, padding: '0 3px',
            backgroundColor: 'rgb(188, 202, 227)', marginRight: 2
        };

        return [
            <WActionButton
                label='Erneut laden'
                action='reload'
                key='action_reload'
                onAction={() => this.triggerService.fire('admin_reload', IDs.ENT_REGISTRIERUNG, () => this.loadData())}
                tooltip='Neu laden'
                place='bottom'
            />,
            <label style={style}>
                <input
                    type='checkbox'
                    checked={this.state.showSchulung}
                    onChange={(event: any) => this.setState({ showSchulung: event.target.checked })}
                />
                Schulungstools anzeigen
            </label>
        ];
    }

    customValidate(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void): string {
        if (key === 'name') {
            if (value && value !== '') {
                const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-]/g, '');
                if (newVal !== value) {
                    onValueChange('name', newVal);
                }
            }
        }
        if (key === 'vorname') {
            if (value && value !== '') {
                const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-\. ]/g, '');
                if (newVal !== value) {
                    onValueChange('vorname', newVal);
                }
            }
        }
        if (key === 'plz') {
            if (value && value !== '') {
                const newVal = value.replace(/[^0-9]/g, '').substr(0, 5);
                if (newVal !== value) {
                    onValueChange('plz', newVal);
                }
            }
        }
        if (key === 'telefon') {
            if (value && value !== '') {
                const newVal = value.replace(/[^0-9+-/]/g, '');
                if (newVal !== value) {
                    onValueChange('telefon', newVal);
                }
            }
        }
        if (key === 'mail') {
            if (value && value !== '') {
                if (value.toLowerCase() !== this.mails[data.values.tid || null] && Object.values(this.mails).indexOf(value.toLowerCase()) > -1) {
                    return 'E-Mail-Adresse existiert bereits.';
                }
            }
        }
        if (key === 'active') {
            if (!data.values.tid && +data.values.active === 1 && +data.values.mail_confirmed === 1) {
                onValueChange('by_berater', true, false);
                // onValueChange('password', 'auto', false);
            }
        }
        return undefined;
    }
}
